import React,{useState} from 'react'
import { useAppData } from '../../../../context/AppDataContext';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Switch } from '@mui/material';
import { useAlert } from '../../../../context/AlertContext';
import { businessDays } from '../scheduleServices';
import scheduleUpdateServices from '../scheduleUpdateServices';
import { DoubleArrow, Info } from '@mui/icons-material';



export const  _selectedBusinessDays = [
    {dayName:"Monday", dayNo:1,dayStatus:true},
    {dayName:"Tuesday", dayNo:2,dayStatus:true},
    {dayName:"Wednesday", dayNo:3,dayStatus:true},
    {dayName:"Thursday", dayNo:4,dayStatus:true},
    {dayName:"Friday", dayNo:5,dayStatus:true},
    {dayName:"Saturday", dayNo:6,dayStatus:false},
    {dayName:"Sunday", dayNo:7,dayStatus:false},
];

function BusinessHourSetup({callBack}) {
    const { associateBusinessHours,getAssociateBusinessHours} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);

    const {AppAlert} = useAlert();
    const [savingInProgress, setSavingStatus] = useState(false);
    const {associatedClinicList,getAppDataById} = useAppData();
    
    const [shift1ClinicId,          setShift1ClinicId] = useState("");
    const [shift1StartTime,         setShift1StartTime] = useState("10:00");
    const [shift1EndTime,           setShift1EndTime] =useState("13:00");
    const [shift1AvgProcessTime,    setShift1AvgProcessTime] = useState(15);
    const [shift1MaxToken,          setShift1MaxToken] = useState(1);

    const [shift2ClinicId,          setShift2ClinicId] = useState("");
    const [shift2StartTime,         setShift2StartTime] = useState("14:00");
    const [shift2EndTime,           setShift2EndTime] =useState("17:00");
    const [shift2AvgProcessTime,    setShift2AvgProcessTime] = useState(15);
    const [shift2MaxToken,          setShift2MaxToken] = useState(1);

    const [selectedBusinessDays,setSelectedBusinessDays] = useState(_selectedBusinessDays);


    const onSubmit = () =>{

        let payload ={
            shift1ClinicId:shift1ClinicId,
            shift1StartTime:shift1StartTime,
            shift1EndTime:shift1EndTime,
            shift1AvgProcessTime:shift1AvgProcessTime,
            shift1MaxToken:shift1MaxToken,

            shift2ClinicId:shift2ClinicId,
            shift2StartTime:shift2StartTime,
            shift2EndTime:shift2EndTime,
            shift2AvgProcessTime:shift2AvgProcessTime,
            shift2MaxToken:shift2MaxToken,
            
            selectedBusinessDays:selectedBusinessDays,
        }
        setSavingStatus(true);
        scheduleUpdateServices.setup(payload).then(res=>{
            console.log(res);
            setDialogStatus(false);
            getAssociateBusinessHours();
            callBack();

        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setSavingStatus(false)
        })
        

    }

    const handleShift1ClinicChange = (e) =>{
        setShift1ClinicId(e.target.value)
    }
    const handleShift2ClinicChange = (e) =>{
        setShift2ClinicId(e.target.value)
    }

    const handleDayStatusChange = (dayStatus,i) =>{
        let __selectedBusinessDays = [...selectedBusinessDays];
        __selectedBusinessDays[i].dayStatus = dayStatus;
        setSelectedBusinessDays(__selectedBusinessDays);
    }

    const handleClose = () =>{
        setDialogStatus(false)
    }
    return (
        associateBusinessHours && associateBusinessHours.length == 0 &&
        <>
            <div className="alert alert-warning m-2">
                <h4 className="alert-heading">No Schedule Defined</h4>
                <p>You haven't setup any schedule please define your business hours</p>
                <hr/>
                <p className="mb-0"><button className='btn btn-success' onClick={()=>setDialogStatus(true)}>Setup Business Hours</button></p>
            </div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >   
                <DialogTitle>Setup Business Hours</DialogTitle>
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='card'>
                                <div className='card-header bg-success text-white'>Morning</div>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-md-12 mb-2'>
                                            <label className="form-label fw-bold">Select Clinic</label>
                                            <select value={shift1ClinicId} onChange={handleShift1ClinicChange} className='form-control' >
                                                <option value={""}>--Select Clinic--</option>
                                                {associatedClinicList && associatedClinicList.map(clinic =>
                                                    <option value={clinic.id}>{clinic.title}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="form-label fw-bold">Start Time</label>
                                            <input className='form-control' type="time" value={shift1StartTime} onChange={(e)=>setShift1StartTime(e.target.value)}  ></input>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">End Time</label>
                                            <input className='form-control' type="time" value={shift1EndTime} onChange={(e)=>setShift1EndTime(e.target.value)}  ></input>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">Slot Time (In Minutes)</label>
                                            <input className='form-control' type="number" value={shift1AvgProcessTime} 
                                                onChange={
                                                    (e)=>{
                                                        if(e.target.value>=15){
                                                            setShift1AvgProcessTime(e.target.value)
                                                        }
                                                    }
                                                }  
                                            />
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">Max Visitor Per Slot</label>
                                            <input className='form-control' type="number" value={shift1MaxToken} 
                                                onChange={
                                                    (e)=>{
                                                        if(e.target.value>=1){
                                                            setShift1MaxToken(e.target.value)
                                                        }
                                                    }
                                                }  
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <div className='col-md-6'>
                            <div className='card'>
                                <div className='card-header bg-warning'>Evening</div>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-md-12 mb-2'>
                                            <label className="form-label fw-bold">Select Clinic</label>
                                            <select value={shift2ClinicId} onChange={handleShift2ClinicChange} className='form-control' >
                                                <option value={""}>--Select Clinic--</option>
                                                {associatedClinicList && associatedClinicList.map(clinic =>
                                                    <option value={clinic.id}>{clinic.title}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="form-label fw-bold">Start Time</label>
                                            <input className='form-control' type="time" value={shift2StartTime} onChange={(e)=>setShift2StartTime(e.target.value)}  ></input>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">End Time</label>
                                            <input className='form-control' type="time" value={shift2EndTime} onChange={(e)=>setShift2EndTime(e.target.value)}  ></input>
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">Slot Time (In Minutes)</label>
                                            <input className='form-control' type="number" value={shift2AvgProcessTime} 
                                                onChange={
                                                    (e)=>{
                                                        if(e.target.value>=15){
                                                            setShift2AvgProcessTime(e.target.value)
                                                        }
                                                    }
                                                }  
                                            />
                                        </div>
                                        <div className='col-md-12 mb-2'>
                                            <label className="fform-label fw-bold">Max Visitor Per Slot</label>
                                            <input className='form-control' type="number" value={shift2MaxToken} 
                                                onChange={
                                                    (e)=>{
                                                        if(e.target.value>=1){
                                                            setShift2MaxToken(e.target.value)
                                                        }
                                                    }
                                                }  
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <h4>Select Your Business Days</h4>
                            {selectedBusinessDays.map((businessDay,i) =>
                                <span className='m-2 border rounded p-2'>
                                    <Switch checked={businessDay.dayStatus} onChange={(e)=>handleDayStatusChange( e.target.checked,i)} /> {businessDay.dayName}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                        <div className="alert alert-info d-flex align-items-center" >
                            <Info/>
                            <div className=''>You can update your working hours later</div>
                        </div>
                        
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline btn-lg' onClick={handleClose} >Close</button>
                    {savingInProgress ?
                        <CircularProgress/>
                        :
                        <button className='btn btn-success btn-lg' onClick={onSubmit} disabled={shift1ClinicId=="" || shift2ClinicId == "" || shift1AvgProcessTime < 10 || shift2AvgProcessTime <= 10}  >Save and continue <DoubleArrow/> </button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BusinessHourSetup